import { FirmAccountsAgGrid } from './firmAccountsAgGrid';

export interface FirmAccountsAgGridProps {
    firmId: string;
    showClosedAccounts: boolean;
}

export default FirmAccountsAgGrid;